<section class="masthead">
  <div class="flex-toolbar" data-options="{maxVisibleButtons: 6}">
    <div class="toolbar-section">
      <button type="button" class="masthead-icon">
        <svg class="icon icon-logo" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-logo"></use>
        </svg>
        <span class="audible">Go To Home</span>
      </button>
    </div>

    <div class="toolbar-section title">
      <h1 class="masthead-appname" (click)="RedirectToHome()" style="cursor: pointer;">Infor Capacity Model</h1>
      
    </div>
    <div class="toolbar-section buttonset">
      <button type="button" class="btn btn-menu">
        <img id="insn_userprofile_snap_img" alt="image" class="image-round"
          style="width:30px;height: 30px;visibility: hidden;">
        <span id="lblEmployeeName" style="font-size: 1.2rem;padding-left: 10px;vertical-align: super;">
        </span>
      </button>
    </div>
  </div>
</section>